import type { CommandBody } from '../CrossOriginMessage';

/**
 * Indicates a class change generated by object list.
 */
export class ObjectListClassChangedCommandBody implements CommandBody {
  classId: string;
}
